(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('bagDetailSkeleton', {
            templateUrl: 'app/admin/bag/skeleton/bag-detail/bag-detail-skeleton.html',
            controller: skeletonFieldController,
            bindings: {
                visible: '<?',
                tab: '<?',
                isEditMode: '<?',
                isImmoContext: '<?',
                storeCategory: '<?'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function skeletonFieldController() {
        var vm = this;
        vm.$onInit = init;

        function init() {
            vm.visible = vm.visible || false;
            vm.tab = vm.tab || 1;
            vm.isEditMode = vm.isEditMode || false;
            vm.isImmoContext = vm.isImmoContext || false;
            vm.storeCategory = vm.storeCategory || null;
        }

        vm.getTranslateKey = function (key) {
            return getTranslateKey(vm.isImmoContext,  key);
        }
    }
})();
